import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userSetter",
  initialState: {
    role: "",
    companyType: "",
    companyLevelComplaiceFlag: false,
    userEmail: "",
    userId: "",
    userFlow: "",
    companyName: "",
    companyId: "",
  },
  reducers: {
    setUserRole: (state, action) => {
      state.role = action.payload;
    },
    setCompanyType: (state, action) => {
      state.companyType = action.payload;
    },
    setCompanyLevelComplaiceFlag: (state, action) => {
      state.companyLevelComplaiceFlag = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setUserFlow: (state, action) => {
      state.userFlow = action.payload;
    },
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
    },
    setCompanyId: (state, action) => {
      state.companyId = action.payload;
    },
    resetUserData: (state) => {
      state.role = "";
      state.companyType = "";
      state.companyLevelComplaiceFlag = false;
      state.userEmail = "";
      state.userFlow = "";
      state.companyName = "";
      state.companyId = "";
    },
  },
});

export const {
  setUserRole,
  setCompanyType,
  setCompanyLevelComplaiceFlag,
  setUserEmail,
  setUserId,
  setUserFlow,
  resetUserData,
  setCompanyName,
  setCompanyId,
} = userSlice.actions;

export default userSlice.reducer;
